import React from 'react';
import { gql } from '@soundxyz/gql-string';
import { CoverImages } from '@components/Playlists/basics/CoverImages';
import { PlayButton } from '@components/main-components/play-button/PlayButton';
import type { FragmentType } from '@graphql/reactQuery';
import { FeedPostModalPlaylistSelectItemFragmentDoc, getFragment } from '@graphql/reactQuery';
import { usePlaylistPlayingState } from '@hooks/usePlaylistPlayingState';
import { getSingularOrPlural } from '@utils/helpers';
import { SelectResourceUI } from './SelectResourceUI';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment FeedPostModalPlaylistSelectItem on Shelf {
    id
    name
    webappUri
    releaseCount
    user {
      id
      webappUri
      username
    }
    ...PlaylistCoverImages
  }
`);

export function PlaylistSelectItem({
  playlistFrag,
  selected,
  onPlaylistSelected,
}: {
  playlistFrag: FragmentType<FeedPostModalPlaylistSelectItemFragmentDoc>;
  selected: boolean;
  onPlaylistSelected: () => void;
}) {
  const playlist = getFragment(FeedPostModalPlaylistSelectItemFragmentDoc, playlistFrag);

  const { isPlaying, onPlayButtonClick, loading } = usePlaylistPlayingState({
    playlistId: playlist.id,
  });
  const {
    name,
    user: { username },
    releaseCount,
  } = playlist;

  const cover = (
    <div className="group relative h-12 w-12 overflow-hidden rounded-md ">
      <CoverImages playlist={playlist} maxSize={48} priority />;
      <div
        data-state={isPlaying ? 'playing' : 'paused'}
        className="absolute top-0 flex h-full w-full items-center justify-center transition-opacity duration-300  ease-in-out data-[state=playing]:opacity-100 group-hover:data-[state=paused]:opacity-100  lg:opacity-0  [&_.play-button-container]:h-12  [&_.play-button-container]:w-12 "
      >
        <PlayButton
          color="transparent"
          size="s"
          onClick={onPlayButtonClick}
          playing={isPlaying}
          disabled={releaseCount === 0}
          loading={loading}
          elevated
          currentListeningParty={null}
        />
      </div>
    </div>
  );
  return (
    <SelectResourceUI
      cover={cover}
      onClick={onPlaylistSelected}
      title={name}
      name={username}
      selected={selected}
      subText={`${releaseCount} ${getSingularOrPlural({
        word: 'sound',
        count: releaseCount,
      })}`}
    />
  );
}
